import { pdsTv } from '@nestle-npus-nbm/pds-ui';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import { merge } from 'lodash';
import React from 'react';
import { Container } from 'react-bootstrap';
import { CMS_THEME } from '../../common/enums';
import { StorageContentBlock } from '../common/StorageContentBlock/StorageContentBlock';

interface StoragePageTitleProps {
  node: IStoragePageTitle;
}

const DefaultSettings = {
  entity_variant: {
    theme: CMS_THEME.LIGHT,
  },
};

const containerStyles = pdsTv({
  base: 'pds-py-5 lg:pds-py-6',
  variants: {
    theme: {
      light: 'pds-bg-surface',
      dark: 'pds-bg-neutral',
      neutral: 'pds-bg-surface-layer',
    },
  },
});

const StoragePageTitle: React.FC<StoragePageTitleProps> = ({ node: pageTitle }) => {
  const settings = merge({}, DefaultSettings, pageTitle?.behaviors);
  const cmsTheme = settings.entity_variant.theme;

  const containerStyle = React.useMemo(() => {
    return containerStyles({
      theme: cmsTheme,
    });
  }, [cmsTheme]);

  const analyticsCallback = (link: LinkProps, index: number) => {
    sendIt({
      event: 'module_interaction',
      eventParams: {
        component_id: `${index === 0 ? 'primary_cta' : 'secondary_cta'}: ${link.title}`,
        component_type: 'page_title',
        content_name: pageTitle.title,
      },
    });
  };

  return (
    <Container
      id={pageTitle.component_id}
      data-id={pageTitle.drupal_id}
      className={containerStyle}
      fluid
    >
      <Container>
        <StorageContentBlock
          node={{ ...pageTitle, behaviors: settings }}
          actionCallback={analyticsCallback}
        />
      </Container>
    </Container>
  );
};

export default StoragePageTitle;
